
<div class="main">
    <p *ngIf="!expiredSession">Your session will expire in <span>{{parsedTime}}</span> due to inactivity. Do you want to extend the session? Otherwise you will need to refresh the page.</p>


    <p *ngIf="expiredSession"><span>Your session has expired.</span> Please refresh the page to continue.</p>

    <div class="main__buttons">
        <button motifButton color="primary" *ngIf="expiredSession" (click)="refreshPage()">
            Refresh Session
        </button>
        
        <button motifButton color="primary" *ngIf="!expiredSession" (click)="extendSession()">
            Extend Session
        </button>
    </div>

</div>

